import $ from 'jquery';
import {breakpoint} from '../site/breakpoint';

export class AccordionNav {
  constructor($el) {
    this.$el =  $el;
    this.$trigger = $('.js-nav-toggle');
    this.$items = $el.find('.js-nav-item');
    
    this.bindEvents();
  }
  
  bindEvents() {
    this.$trigger.on('click', event => this.onNavToggleClick(event));
    this.$items.filter('.js-has-submenu').on('click','.js-collapse-toggle', event => this.onItemClick(event));
    
  }
  
  onNavToggleClick(event) {
    // Prevent this click from being counted
    // as a document click
    event.stopPropagation();
    
    this.toggleNavMenu();
  }
  
  onItemClick(event) {
    // Prevent this click from being counted
    // as a document click
    event.stopPropagation();
    
    let $clickedItem = $(event.target).closest('.js-nav-item');
    this.toggleCollapsingMenu($clickedItem);
  }
  
  toggleNavMenu() {
    $('body').toggleClass('is-off-canvas');
  }
  
  toggleCollapsingMenu($item) {
    let $submenu = $item.children('.js-submenu');
    
    if ($item.hasClass('is-open')) {
      $submenu.slideUp(300);
    } else {
      $submenu.slideDown(300);
    }
    
    $item.toggleClass('is-open');
  }
}
